import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AboutComponent } from './about/about.component';
import { SolutionsComponent } from './solutions/solutions.component';
import { FinesseComponent } from './solutions/finesse/finesse.component';
import { FiscalComponent } from './solutions/fiscal/fiscal.component';
import { ServicesComponent } from './services/services.component';
import { ClientsComponent } from './clients/clients.component';
import { ContactUsComponent } from './contactus/contactus.component';
import { NewsComponent } from './news/news.component';

const appRoutes: Routes = [ 
    {
        path: 'about',
        component: AboutComponent
    },
    {
        path: 'solutions',
        component: SolutionsComponent
    },
    {
        path: 'services',
        component: ServicesComponent
    },
    {
        path: 'clients',
        component: ClientsComponent
    },
    {
        path: 'contact/:id',
        component: ContactUsComponent
    },
    {
        path: 'contact',
        component: ContactUsComponent
    },
    {
        path: 'news/:id',
        component: NewsComponent
    },
    {
        path: 'solutions/finesse',
        component: FinesseComponent
    },
    {
        path: 'solutions/fiscal',
        component: FiscalComponent
    },
    {
        path: '',
        redirectTo: '/about',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: '/about'
    },

   
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


/** WEBPACK FOOTER **
 ** ./src/app/routes.ts
 **/